import React, {Component} from 'react';
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import Table from "@amzn/meridian/table";
import TableCell from "@amzn/meridian/table/table-cell";
import TableRow from "@amzn/meridian/table/table-row";
import {chainWalk, formQueryParams} from "../Utility";
import {FormattedMessage} from "react-intl";
import Link from "@amzn/meridian/link";
import Loading from "./utils/Loading";
import ErrorPage from "./utils/ErrorPage";
import {navigationAdded} from "../actions/OptionsActions";
import {PackageStatus} from "../enums";
import {CYCLE, HYPHEN, TOTAL} from "../constants";
import RefreshTimer from "./RefreshTimer";
import Column from "@amzn/meridian/column";

class Zone extends Component {

    render() {
        const error = this.props.error
        const stowPackageMetricsMap = this.props.stowPackageMetricsMap

        if (error) {
            return <ErrorPage errorId="stow.error" errorMessage="Some error occurred"/>
        }
        const zones = this.filteredZones();

        if (this.props.loading && !zones.length) {
            return <Loading height={"400px"}/>;
        }

        return (
            <Column>
                <RefreshTimer deps={[stowPackageMetricsMap]} />
                <Table headerRows={2} showDividers={false} showStripes={false} spacing="small" fixHeaderRows={true}
                       fixHeaderRowsFullWidth={true}>
                    {this.renderHeadings()}
                    {this.renderSubHeadings()}
                    {zones.map((zone) => (this.renderPackageMetrics(zone)))}
                    {zones.length ? this.renderTotalPackageMetrics() : null}
                </Table>
            </Column>
        )
    }

    getDistinctZones = () => {
        const allZones = [
            ...Object.keys(this.props.stowPackageMetricsMap),
        ];
        const filteredZones = allZones.filter(zone => zone !== "")

        return [...new Set(filteredZones)];
    }

    /**
     * This function will return the distinct zones which have packages planned.
     * @returns list of zones
     */
    filteredZones = () => {
        const zones = this.getDistinctZones().sort()
        const {
            stowPackageMetricsMap
        } = this.props;
        return zones.filter(zone => {
            return Boolean(stowPackageMetricsMap[zone].currentInductedPackages
                + stowPackageMetricsMap[zone].stowedPackages
                + stowPackageMetricsMap[zone].problemSolvePackages)
        })
    }

    renderHeadings = () => {
        return (
            <TableRow>
                <TableCell/>
                <TableCell>
                    <FormattedMessage id="zone.packages" defaultMessage="Packages"/>
                </TableCell>
                <TableCell/>
                <TableCell/>
                <TableCell/>
                <TableCell>
                    <FormattedMessage id="zone.performance" defaultMessage="Performance"/>
                </TableCell>
                <TableCell/>
                <TableCell>
                    <FormattedMessage id="zone.stowers" defaultMessage="Stowers"/>
                </TableCell>
            </TableRow>
        );
    }

    renderSubHeadings = () => {
        return (
            <TableRow>
                <TableCell>
                    <FormattedMessage id="zone.zone" defaultMessage="Zone"/>
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    <FormattedMessage id="zone.inducted" defaultMessage="Inducted"/>
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    <FormattedMessage id="zone.stowed" defaultMessage="Stowed"/>
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    <FormattedMessage id="zone.ps" defaultMessage="Problem Solve"/>
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    <FormattedMessage id="zone.stow_rate" defaultMessage="Stow rate"/>
                </TableCell>
                <TableCell sortColumn="scanCompliance" alignmentHorizontal="right">
                    <FormattedMessage id="zone.scan_complaince" defaultMessage="Scan comp."/>
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    <FormattedMessage id="zone.active" defaultMessage="Active"/>
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    <FormattedMessage id="zone.inactive" defaultMessage="Inactive"/>
                </TableCell>
            </TableRow>
        );
    }

    renderPackageMetrics = (zone) => {
        const combinedMetricsMap = this.getCombinedMetricsMap(zone)

        return (
            <TableRow highlightOnHover={true} key={zone} onClick={() => this.zoneRowClicked(zone, combinedMetricsMap.displayLabel)}>
                <TableCell>{combinedMetricsMap.displayLabel}</TableCell>
                <TableCell alignmentHorizontal="right">
                    {this.renderPackageCount(combinedMetricsMap.inductedPackages, zone, PackageStatus.CURRENT_INDUCTED)}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {this.renderPackageCount(combinedMetricsMap.stowedPackages, zone, PackageStatus.STOWED)}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {this.renderPackageCount(combinedMetricsMap.problemSolvePackages, zone, PackageStatus.PROBLEM_SOLVE)}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {combinedMetricsMap.stowRate}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {combinedMetricsMap.scanCompliance}%
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {combinedMetricsMap.activeStowers}</TableCell>
                <TableCell alignmentHorizontal="right">
                    {combinedMetricsMap.inactiveStowers}</TableCell>
            </TableRow>
        );
    }

    renderTotalPackageMetrics = () => {
        const combinedTotalMetricsMap = this.getCombinedTotalMetricsMap()

        return (
            <TableRow>
                <TableCell>Total</TableCell>
                <TableCell alignmentHorizontal="right">
                    {combinedTotalMetricsMap.inductedPackages}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {combinedTotalMetricsMap.stowedPackages}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {combinedTotalMetricsMap.problemSolvePackages}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {combinedTotalMetricsMap.stowRate}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {combinedTotalMetricsMap.scanCompliance}%
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {combinedTotalMetricsMap.activeStowers}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {combinedTotalMetricsMap.inactiveStowers}
                </TableCell>
            </TableRow>
        );
    }

    getCombinedMetricsMap = zone => {
        const {
            stowAssociateMetricsMap,
            stowPackageMetricsMap
        } = this.props;
        const defaultMetricValue = HYPHEN

        const displayLabel = chainWalk(() => stowPackageMetricsMap[zone].displayLabel, HYPHEN)
        return {
            inductedPackages: chainWalk(() => stowPackageMetricsMap[zone].currentInductedPackages, defaultMetricValue),
            stowedPackages: chainWalk(() => stowPackageMetricsMap[zone].stowedPackages, defaultMetricValue),
            problemSolvePackages: chainWalk(() => stowPackageMetricsMap[zone].problemSolvePackages, defaultMetricValue),
            displayLabel: displayLabel,
            stowRate: chainWalk(() => stowPackageMetricsMap[zone].stowRate, defaultMetricValue),
            scanCompliance: chainWalk(() => stowPackageMetricsMap[zone].scanCompliance, defaultMetricValue),
            activeStowers: chainWalk(() => stowAssociateMetricsMap[zone].activeStowers, defaultMetricValue),
            inactiveStowers: chainWalk(() => stowAssociateMetricsMap[zone].inactiveStowers, defaultMetricValue),
        }
    }

    getCombinedTotalMetricsMap = () => {
        const {
            totalStowAssociateMetrics,
            totalStowPackageMetrics
        } = this.props;
        const defaultMetricValue = HYPHEN
        const zone = TOTAL

        return {
            inductedPackages: chainWalk(() => totalStowPackageMetrics[zone].currentInductedPackages, defaultMetricValue),
            stowedPackages: chainWalk(() => totalStowPackageMetrics[zone].stowedPackages, defaultMetricValue),
            problemSolvePackages: chainWalk(() => totalStowPackageMetrics[zone].problemSolvePackages, defaultMetricValue),
            stowRate: chainWalk(() => totalStowPackageMetrics[zone].stowRate, defaultMetricValue),
            scanCompliance: chainWalk(() => totalStowPackageMetrics[zone].scanCompliance, defaultMetricValue),
            activeStowers: chainWalk(() => totalStowAssociateMetrics[zone].activeStowers, defaultMetricValue),
            inactiveStowers: chainWalk(() => totalStowAssociateMetrics[zone].inactiveStowers, defaultMetricValue),
        }
    }

    zoneRowClicked = (zone, displayLabel) => {
        this.props.dispatch(navigationAdded({
            key: 'Zone',
            value: zone,
            displayValue: displayLabel
        }))
    }

    renderPackageCount = (value, zone, state) => {
        return value !== 0 && value !== '-' ?
            <Link href={this.getPackageListURL(state, zone)}
                  type="secondary"> {value} </Link> : value
    }

    getPackageListURL = (state, zone) => {
        const params = {
            PACKAGE_STATUS: state,
            CLUSTER: zone
        }
        const options = this.props.options
        if (options.cycle) {
            params[CYCLE] = options.cycle;
        }
        return "#packageList/?" + formQueryParams(params);
    }
}

const mapStateToProps = state => ({
    loading: state.zoneReducer.loading,
    error: state.zoneReducer.error,
    options: state.optionsReducer.options,
    stowAssociateMetricsMap: state.zoneReducer.stowAssociateMetricsMap,
    stowPackageMetricsMap: state.zoneReducer.stowPackageMetricsMap,
    totalStowAssociateMetrics: state.zoneReducer.totalStowAssociateMetrics,
    totalStowPackageMetrics: state.zoneReducer.totalStowPackageMetrics,
});

export default withRouter(connect(mapStateToProps)(Zone));



// WEBPACK FOOTER //
// ./src/components/Zone.js